import HostedHeader from './hostedHeader'

export default HostedHeader
